<template>
  <div>
    <el-row :gutter="16">
      <el-col :span="6"><el-card><div class="stat-label">总用户数</div><div class="stat-value">{{ data.totalUsers }}</div></el-card></el-col>
      <el-col :span="6"><el-card><div class="stat-label">总博主数</div><div class="stat-value">{{ data.totalBloggers }}</div></el-card></el-col>
      <el-col :span="6"><el-card><div class="stat-label">总流水</div><div class="stat-value">¥{{ data.totalRevenue }}</div></el-card></el-col>
      <el-col :span="6"><el-card><div class="stat-label">净收入</div><div class="stat-value">¥{{ data.netIncome }}</div></el-card></el-col>
    </el-row>
    <el-row :gutter="16" style="margin-top:16px">
      <el-col :span="12">
        <el-card><div class="stat-label">今日流水</div><div class="stat-value" style="font-size:24px">¥{{ data.todayRevenue }}</div></el-card>
      </el-col>
      <el-col :span="12">
        <el-card><div class="stat-label">资源总数</div><div class="stat-value" style="font-size:24px">{{ data.totalResources }}</div></el-card>
      </el-col>
    </el-row>

    <el-card style="margin-top:16px">
      <div slot="header" class="font-bold">最近订单</div>
      <el-table :data="data.recentOrders || []" size="small">
        <el-table-column prop="orderNo" label="订单号" width="200" />
        <el-table-column prop="username" label="买家" width="100" />
        <el-table-column prop="resourceTitle" label="资源" />
        <el-table-column prop="actualAmount" label="金额" width="100">
          <template slot-scope="{row}">¥{{ row.actualAmount || row.amount }}</template>
        </el-table-column>
        <el-table-column prop="paidAt" label="支付时间" width="160">
          <template slot-scope="{row}">{{ formatDate(row.paidAt) }}</template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card style="margin-top:16px">
      <div slot="header" class="font-bold">博主收入排行</div>
      <el-table :data="data.topBloggers || []" size="small">
        <el-table-column prop="username" label="博主" width="150" />
        <el-table-column prop="totalIncome" label="累计收入" width="120">
          <template slot-scope="{row}">¥{{ row.totalIncome }}</template>
        </el-table-column>
        <el-table-column prop="withdrawable" label="可提现余额" width="120">
          <template slot-scope="{row}">¥{{ row.withdrawable }}</template>
        </el-table-column>
        <el-table-column prop="auditStatus" label="审核状态" width="100">
          <template slot-scope="{row}">
            <el-tag :type="row.auditStatus==='approved'?'success':row.auditStatus==='rejected'?'danger':'warning'" size="small">
              {{ row.auditStatus === 'approved' ? '已通过' : row.auditStatus === 'rejected' ? '已拒绝' : '待审核' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { adminApi } from '../api';

export default {
  data() {
    return { data: {} };
  },
  created() { this.fetch(); },
  methods: {
    async fetch() {
      const res = await adminApi.dashboard();
      this.data = res.data;
    },
    formatDate(d) {
      if (!d) return '';
      const dt = new Date(d);
      return dt.toLocaleString('zh-CN');
    }
  }
};
</script>

<style scoped>
.stat-label { color: #909399; font-size: 14px; }
.stat-value { font-size: 28px; font-weight: bold; color: #303133; margin-top: 4px; }
</style>
